<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';

import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

import AntifraudList from '@/components/page-antifraud/AntifraudList.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';
import constants from '@/constants';

export default {
    data() {
        return {
            constants: constants,
        };
    },
    components: {
        MainContainer: MainContainer,
        LeftPanel: LeftPanel,
        RightContainer: RightContainer,

        ButtonReturn: ButtonReturn,

        AntifraudList: AntifraudList,
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            {
                dispatch: 'loadAntifraudNotifications',
                commit: null,
                isArray: false,
            },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);
    },
};
</script>

<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <AntifraudList />
        </RightContainer>
    </MainContainer>
</template>
